module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1c.21b9ac85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-3-1c.svg
// module id = 570
// module chunks = 0